import { Box } from '@mui/material'
import GallerySection from './GallerySection'
import { Page_Padding } from '../../shared/constants'
import HowWeAreDifferentSection from './HowWeAreDifferentSection'
import CustomDivider from '../../shared/utils/CustomDivider'
import WhatWeDoSection from './WhatWeDoSection'
import TakeWaysForChildren from './TakeWaysForChildren'
import HeroSection from './HeroSection'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { useEffect } from 'react'
import CourseScroller from '../Home/CourseScroller'
import { COURSE_MAP } from '../../shared/utils/config'
import { useCourses } from '../../assets/api/useGetApi'

const SummerCamp = ({ onLoadingChange = () => { } }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("SUMMER_CAMP");
   
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);
    
    const { flatData:summerCampCoureses, isLoading: isLoadingCourse } = useCourses({course_type:"summer_camp"}, 6); 



    if (isLoading) return null;
    return (
        <Box  >
            <HeroSection bottomData={Detail?.content[1]?.data} heroData={Detail?.content[0]?.data} />
            <Box className="body contact_us">
                <Box px={Page_Padding}>
                    <CustomDivider />
                    <CourseScroller content={Detail?.content[2]} courses={summerCampCoureses} isLoading={isLoadingCourse} category={COURSE_MAP.SUMMER_CAMP} />
                    <CustomDivider />
                    <WhatWeDoSection whatWeDoData={Detail?.content[3]?.data} />
                    <CustomDivider />
                    <HowWeAreDifferentSection howWeDifferenceData={Detail?.content[4]?.data} />
                    <CustomDivider />
                    <CustomDivider />
                </Box>
                <TakeWaysForChildren takeWayData={Detail?.content[5]?.data} />
                <GallerySection galleryCoverData={Detail?.content[6]?.data} galleryData={Detail?.content[7]?.data?.memoryList} />
            </Box>

        </Box>
    )
}

export default SummerCamp
